import { PageHeaderWrapper } from "@clipboard-health/ui-components";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";

export function ShareScoreHeader() {
  return (
    <PageHeaderWrapper
      sx={{
        background: "transparent",
      }}
    >
      <PageHeaderTopRow fallbackGoBackPath="/home/clipboard-score" />
    </PageHeaderWrapper>
  );
}
